import { getInput } from './get-input.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const setValue = /* @__PURE__ */ __name((frame, value) => {
  var _a;
  const input = getInput(frame);
  if (input) {
    const nativeInputValueSetter = (_a = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    )) == null ? void 0 : _a.set;
    nativeInputValueSetter == null ? void 0 : nativeInputValueSetter.call(frame.querySelector("input"), value);
    input.dispatchEvent(new Event("input", { bubbles: true }));
  }
}, "setValue");

export { setValue };
//# sourceMappingURL=set-value.js.map
